import React, { useEffect, useState } from 'react';
import useAxiosPrivate from '../../../hooks/useAxiosPrivate';
import Users from '../../Users';
import DateRange from '../../DateRange';
import { Link, useNavigate } from 'react-router';
import { Button, Card, CardBody, Col, Container, Form, FormGroup, Spinner } from 'reactstrap';
import useFilter from '../../../hooks/useFilter';
import useNavBar from '../../../hooks/useNavBar';

export default function ISODetailReportForm() {
    const axiosPrivate = useAxiosPrivate();
    const navigate = useNavigate();
    const users = Users();
    const dateRange = DateRange();

    const { filter, setFilter } = useFilter();
    const { loading, setLoading } = useNavBar();

    const headers = 
        [
            "Department",
            "Full Name",
            "College ID",
            "Course / Assignment",
            "Completion Date",
            "Duration(hours)",
            "Personnel ID",
            "ISA Topic",
            "ISA Instructor",
            "ISO Category",
        ];

    useEffect(() => {
        if(!users.loading && !dateRange.loading){
            setLoading(false);
        }

        const headersWithActive = users.includeInactiveUsers ? [...headers, "User Status"] : headers;

        setFilter({
            users: users.selectedUsers.map(user => user.value),
            groups: users.selectedGroups.map(group => group.value),
            headers: headersWithActive,
            startDate: dateRange.startDate,
            endDate: dateRange.endDate,
            recordGrouping: (filter?.recordGrouping ?? 0),

            selectAllUsers: users.selectAll,
            formUsers: users.users,            
            formGroups: users.groups,
            includeInactiveUsers: users.includeInactiveUsers,
        });
    }, [users.loading,
        users.selectAll, 
        users.selectedUsers, 
        users.users, 
        users.selectedGroups, 
        users.groups,
        users.includeInactiveUsers,
        dateRange.loading,
        dateRange.startDate, 
        dateRange.endDate]); 

    const handleSubmit = async (e) => {
        e.preventDefault();

        const sendfilter = (
            (
                { users, groups, headers, startDate, endDate, recordGrouping }) =>
                ({ users, groups, headers, startDate, endDate, recordGrouping })
        )(filter);

        try{
            await axiosPrivate.post('api/reports/isaaudit', sendfilter);
            navigate('/reports');
        }
        catch(err){
            console.log(err);
        }
    }

    return (
        loading ? <Spinner variant="primary" animation="border" role="status" className='custom-spinner'/> :
        <Container>
            <Col>
                <FormGroup>                            
                    <Card>
                        <CardBody>
                            <FormGroup>
                                {users.render}
                            </FormGroup>
                        </CardBody>
                    </Card>  
                </FormGroup>
                <FormGroup>
                    <Card>
                        <CardBody>
                            <FormGroup>
                                {dateRange.render}
                            </FormGroup>
                        </CardBody>
                    </Card>  
                </FormGroup>
            </Col>
            <footer>
                <Form onSubmit={handleSubmit}>
                    <Button color="primary">Generate Report</Button>
                    <Link to="/">
                        <Button className='btn-danger'>Back</Button>
                    </Link>
                </Form>
            </footer>
        </Container>
    );
}